<template>
  <AppDialog
    v-model="dialog"
    title="Import Data"
    max-width="1000px"
    @close="close"
  >
    <v-card-text>
      <v-row class="pt-6">
        <v-col>
          <div class="text-black-accent-1">
            Please select a CSV spreadsheet for sightings to import data into the system.
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-file-input
            label="Sightings Upload (.csv)"
            variant="outlined"
            density="compact"
            prepend-icon="google-spreadsheet"
            @change="updateSightingsFile"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-progress-linear
            indeterminate
            :active="saving"
            color="primary"
          />
          <v-alert
            v-if="message && !saved"
            type="error"
          >
            {{ message }}
          </v-alert>
          <v-alert
            v-if="saved"
            type="success"
          >
            {{ message }}
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="close">
        <v-icon>mdi-close</v-icon>
        Close
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!filesPresent || saved"
        @click="save"
      >
        <v-icon>mdi-check</v-icon>
        Upload
      </v-btn>
    </v-card-actions>
  </AppDialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppDialog from "@/components/AppDialog";
import utils from "@/helpers/utils";


export default {
  components: { AppDialog },
  data() {
    return {
      sightingsFile: null,
    };
  },
  computed: {
    ...mapGetters({
      saving: "sighting/import/saving",
      saved: "sighting/import/saved",
      dialog: "sighting/import/dialog",
      message: "sighting/import/message",
    }),
    filesPresent(){
      return this.sightingsFile !== null
    }
  },
  watch: {
    dialog(dialog) {
      if (!dialog) {
        this.setMessage("");
      }
    },
  },
  methods: {
    ...mapActions({
      uploadSightings: "sighting/import/uploadSightingsFile",
      close: "sighting/import/close",
      setMessage: "sighting/import/setMessage",
    }),
    async save() {
      if (!this.sightingsFile.target.files[0]) {
        this.setMessage("Please select an sightings file!");
        return;
      }
      if (!utils.validateUploadFilename(this.sightingsFile.target.files[0].name)) {
        this.setMessage("The sightings file must be a .csv!");
        return;
      }
      await this.uploadSightings({
        file: this.sightingsFile.target.files[0],
      });
    },
    updateSightingsFile(file) {
      this.sightingsFile = file;
    },
  },
};
</script>

<style scoped>
</style>
